import React, { useState, useEffect } from "react";
import { RiSendPlaneFill } from "react-icons/ri";
import ButtonGroup from "./buttonGroup";
import "../../index.css";

const BootstrapTextInput = ({
  isChatLoading,
  firstPDFMessage,
  getUserMessage,
  chats,
  setReset={setReset},
  reset={reset},
  PDF
}) => {
  // const [messages, setMessages] = useState([]);
  const [messages, setMessages] = useState([]);

  console.log("chats in firstPDFMessage", firstPDFMessage )
  useEffect(() => {
    if (chats.length > 0 && chats[0].length > 0) {
      setMessages(chats);
    }
  }, [chats]);

  // console.log("i am chats", chats);
  const handleSendClick = () => {
    const inputElement = document.getElementById("message-input");
    const message = inputElement.value;

    if (message.length > 0) {
      getUserMessage(message);
      const updatedMessages = [...messages, message];
      setMessages(updatedMessages);
      inputElement.value = "";
    }
  };

  const chatContainerStyle = {
    // padding:
    // isChatLoading === 1 ? "25px" : isChatLoading === 2 ? "65px" : "auto",
    //  isChatLoading === 2 ? "65px" : "auto",
    border: "1px solid lightgray"
  };

  return (
    <div style={chatContainerStyle}>
      <div className="chat-container  px-3 pb-3">
        {firstPDFMessage?.summary && (
          <div>
            <ButtonGroup messages={chats} setReset={setReset}/> <p>{firstPDFMessage.summary}</p>
            <p>You might ask the following questions:</p>
            {/* <ul>
              {firstPDFMessage?.keyPoints  &&
                firstPDFMessage?.keyPoints?.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
            </ul> */}
            <ul>
              {firstPDFMessage?.keyPoints &&
                (() => {
                  try {
                    const keyPoints = firstPDFMessage.keyPoints.map(
                      (item, i) => <li key={i}>{item}</li>
                    );
                    return <ul>{keyPoints}</ul>;
                  } catch (e) {
                    console.log(e);
                    return (
                      "Summary and KeyPoints below:" + firstPDFMessage.keyPoints
                    );
                  }
                })()}
            </ul>
          </div>
        )}
        {messages?.map((message, index) => (
          <>
            <div
              key={index}
              className={`chat-message my-1 p-2 ${
                index % 2 === 0 ? "from-me" : "from-ai"
              }`}
            >
              {index % 2 === 0 ? "Me" : "AI"}: {message}
            </div>
            <br />
          </>
        ))}
      </div>
      <div className="input-group" style={{ alignSelf: "flex-end" }}>
        <input
          id="message-input"
          type="text"
          className="form-control rounded me-2"
          placeholder={
            isChatLoading === 1 ? "ai is loading..." : "Ask me anything"
          }
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              console.log("E");
              handleSendClick();
            }
          }}
        />
        {isChatLoading === 1 ? (
          <button className="btn btn-primary" type="button" disabled>
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
        ) : isChatLoading === 0 ? (
          <button
            className="btn btn-primary"
            onClick={handleSendClick}
            disabled={isChatLoading || !PDF}
          >
            <RiSendPlaneFill />
          </button>
        ) : (
          <button className="btn btn-primary" onClick={handleSendClick}>
            <RiSendPlaneFill />
          </button>
        )}
      </div>
    </div>
  );
};

export default BootstrapTextInput;
